module.exports = "https://coursera_assets.s3.amazonaws.com/images/c17ff8ab6d11a83d15db6a447b193e1e.png";